import { useContext } from 'react';

import '../init';
import { windowIsAvailable } from '../utils';
import { LiveLogContext } from '../components/LiveLog/Context';

/**
 * @example const { announce } = useLiveLog();
 * @returns ...
 */
const useLiveLog = () => {
  const context = windowIsAvailable
    ? window.cosmos.liveLogContext ?? LiveLogContext
    : LiveLogContext;

  return useContext(context);
};

export default useLiveLog;
